import { render, staticRenderFns } from "./CRMCustomer.vue?vue&type=template&id=7729f872&scoped=true&"
import script from "./CRMCustomer.vue?vue&type=script&lang=js&"
export * from "./CRMCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CRMCustomer.vue?vue&type=style&index=0&id=7729f872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7729f872",
  null
  
)

export default component.exports